document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.slider');
  sliders.forEach(function(slider) {
    setInterval(function() {
      const scrollAmount = slider.offsetWidth;
      if (slider.scrollLeft + scrollAmount >= slider.scrollWidth) {
        slider.scrollLeft = 0;
      } else {
        slider.scrollLeft += scrollAmount;
      }
    }, 4000);
  });
});
